export default {
  confirmDelete: '确定要删除吗？此操作不可恢复',
  confirmLogout: '确定要退出登录吗？',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  updateSuccess: '更新成功',
  updateFailed: '更新失败',
  networkError: '网络错误，请稍后重试',
  serverError: '服务器错误，请稍后重试',
  timeout: '请求超时，请稍后重试',
  addSuccess: '新增成功',
  editSuccess: '编辑成功',
  actionSuccess: '操作成功',
  actionFailed: '操作失败',
  fetchFailed: '获取数据失败',
  pleaseSelectProduct: '请选择产品',
};
